import {
  HELP,
  DASHBOARD,
  LM_DASHBOARD,
  HR_DASHBOARD,
  LANDING,
  LEGACY_MY_APPROVALS,
  PENDING_APPROVALS,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {lazy} from 'react'
import {NotificationRoutes} from './notification.routes'
import {EssRoutes} from './ess.routes'
import {HrmRoutes} from './hrm.routes'
import {SettingsRoutes} from './settings.routes'
import {LeaveAttnRoutes} from './leave-attn.routes'
import {PayrollRoutes} from './payroll.routes'
import {ApprovalsRoutes} from './approvals.routes'
import {ReportsRoutes} from './reports.routes'
import {guard, guardLineManagerFeature} from './route-guard'
import LandingRedirect from '../LandingRedirect'

const Error404 = lazy(() => import('pages/errors/ErrorsPage'))

export const AppRouteList: IAppRoutes[] = [
  {
    // Not feature-guarded on purpose — every guard's fallback lands here, and it forwards to the
    // first dashboard or screen the user is granted.
    link: LANDING,
    element: lazy(() => import('pages/landing/Landing')),
  },
  {
    // Employee dashboard (HRM_DASH_MY).
    link: DASHBOARD,
    element: guard(() => import('pages/dashboard/EmployeeDashboard'), [DASHBOARD]),
  },
  {
    // Line-manager dashboard (HRM_DASH_TEAM) — the grant AND ≥1 direct report.
    link: LM_DASHBOARD,
    element: guardLineManagerFeature(() => import('pages/dashboard/ManagerDashboard'), [LM_DASHBOARD]),
  },
  {
    // HR/admin dashboard (HRM_DASH_HR) — the confidential, company-wide view.
    link: HR_DASHBOARD,
    element: guard(() => import('pages/dashboard/DashboardWrapper'), [HR_DASHBOARD]),
  },
  {
    link: HELP,
    element: lazy(() => import('pages/help/HelpPage')),
  },
  {...NotificationRoutes},
  {...EssRoutes},
  {...HrmRoutes},
  {...LeaveAttnRoutes},
  {...SettingsRoutes},
  {...PayrollRoutes},
  {...ApprovalsRoutes},
  {
    // The retired per-type approval pages: an old bookmark or bell link opens the one queue.
    link: LEGACY_MY_APPROVALS,
    redirect: PENDING_APPROVALS,
  },
  {...ReportsRoutes},
  {
    // The sso hand-off lands here: the role's landing page in this app, else the dashboard.
    link: 'auth/*',
    element: LandingRedirect,
  },
  {
    link: '*',
    element: Error404,
  },
]
